import { Component, Input } from '@angular/core';
import { WindowService } from '../../../../../common/angular-shared/services/window/window.service';
import { GenesysContext, GenesysParticipantData } from '../../../../../common/js/types/CommonTypes';
import { AgentAmorphicService } from '../../../../../coverpath-agent/public/js/services/amorphic/amorphic.service';
const GENESYS_SCRIPT_URL = 'https://apps.usw2.pure.cloud/genesys-bootstrap/genesys.min.js';

@Component({
  selector: 'genesys-constellation',
  templateUrl: './genesys-constellation.component.html',
})
export class GenesysConstellationComponent {
  @Input() participantData: GenesysParticipantData = null;
  webMessengerEnabled: boolean = false;
  cobrowseEnabled: boolean = false;
  cobrowseSecurityKeyWindowActive: boolean = false;
  videoEngagerEnabled: boolean = false;
  channelSelectorActive: boolean = false;
  is1851: boolean = false;
  enableGenesysCobrowse: boolean;

  constructor(private amorphicService: AgentAmorphicService, private windowService: WindowService) {}

  ngOnInit() {
    const controller = this.amorphicService.controller;
    const genesysDeploymentId = this.amorphicService.controller.amorphic.config.nconf.get('genesysDeploymentId');
    this.windowService.nativeWindow.executeGenesys('Genesys', GENESYS_SCRIPT_URL, {
      environment: 'usw2',
      deploymentId: genesysDeploymentId,
    });
    this.enableGenesysCobrowse = controller.enableGenesysCobrowse;
    if (this.enableGenesysCobrowse) {
      this.presetCobrowse();
    }
    if (this.participantData) {
      this.preFillGenesysWidget();
      if (this.participantData['WP-Context'] === GenesysContext.COVERPATH_CLIENT) {
        if (this.enableGenesysCobrowse) {
          this.cobrowseEnabled = true;
        }
        this.webMessengerEnabled = true;
      }
    }
  }

  openChannelSelector() {
    if (this.channelSelectorActive) {
      this.windowService.nativeWindow.CXBus.command('ChannelSelector.close');
    } else {
      this.windowService.nativeWindow.CXBus.command('ChannelSelector.open');
      document.getElementById('cobrowse-security-form').innerHTML = '';
      this.cobrowseSecurityKeyWindowActive = false;
    }
  }

  presetCobrowse() {
    this.windowService.nativeWindow.genesysWebchat = (() => {
      const createCobrowseConfig = () => {
        return {
          // Web chat application URL. Use the correct top-level domain for your Genesys Cloud region, i.e. apps.mypurecloud.ie, apps.mypurecloud.jp, apps.mypurecloud.co.uk.
          webchatAppUrl: 'https://apps.usw2.pure.cloud/webchat',
          // Web chat service URL
          webchatServiceUrl: 'https://realtime.usw2.pure.cloud:443',
          // Numeric organization ID
          orgId: 3788,
          // OrgGuid. Needed for co-browse with voice.
          orgGuid: 'c79e7397-2468-4d39-afb3-7f8f1329b966',
          // Organization name
          orgName: 'massmutual',
          // Log level
          logLevel: 'DEBUG',
          // Locale code
          locale: 'en',
          // CSS class applied to the security key window, but not its contents
          cssClass: 'webchat-frame',
          // Custom style applied to the security key window, but not its contents
          css: {
            width: '100%',
            height: '100%',
          },
          // Optional CSS for styling security key form
          contentCssUrl: `${this.windowService.nativeWindow.location.origin}/dist/mm-direct/help-chat.css?ver=0`,
          // Element id where the security key form will appear.
          containerEl: 'cobrowse-security-form',
          // Set to true to display security key form. Do not include for co-browse with web chat or for PureConnect co-browse with voice.
          promptForSecurityKey: true,
        };
      };
      return {
        startCobrowse: () => {
          const config = createCobrowseConfig();
          // Can also use callback
          this.windowService.nativeWindow.ININ.cobrowse
            .create(config)
            .then((result) => {
              // Handle success
              this.cobrowseSecurityKeyWindowActive = false;
            })
            .catch((err) => {
              // Handle failure
              this.cobrowseSecurityKeyWindowActive = false;
            });
        },
      };
    })();
  }

  openMessenger() {
    this.windowService.nativeWindow.Genesys(
      'command',
      'Messenger.open',
      {},
      (o) => {
        if (this.channelSelectorActive) {
          this.windowService.nativeWindow.CXBus.command('ChannelSelector.close');
        }
        document.getElementById('cobrowse-security-form').innerHTML = '';
        this.cobrowseSecurityKeyWindowActive = false;
      },
      (o) => {
        this.windowService.nativeWindow.Genesys('command', 'Messenger.close');
      }
    );
  }

  openCobrowseSecurityForm() {
    if (!this.cobrowseSecurityKeyWindowActive) {
      if (this.channelSelectorActive) {
        this.windowService.nativeWindow.CXBus.command('ChannelSelector.close');
      }
      this.windowService.nativeWindow.genesysWebchat.startCobrowse();
      this.cobrowseSecurityKeyWindowActive = true;
    } else {
      document.getElementById('cobrowse-security-form').innerHTML = '';
      this.cobrowseSecurityKeyWindowActive = false;
    }
  }

  loadVideoEngagerScript() {
    this.windowService.nativeWindow._genesys.widgets.videoengager.webChatFormData = {
      firstname: this.participantData['WP-First-Name'],
      lastname: this.participantData['WP-Last-Name'],
      email: this.participantData['WP-Email'],
      userData: this.participantData,
    };
    const oMyPlugin = this.windowService.nativeWindow._genesys.widgets.bus.registerPlugin('MyPlugin');
    oMyPlugin.subscribe('WebChatService.started', () => {
      this.videoEngagerEnabled = false;
    });
    oMyPlugin.subscribe('WebChatService.ended', () => {
      this.videoEngagerEnabled = true;
    });

    const veHandler = (e) => {
      if (e.data.type === 'popupClosed') {
        this.windowService.nativeWindow.CXBus.command('VideoEngager.endCall');
      }
    };
    if (this.windowService.nativeWindow.addEventListener) {
      this.windowService.nativeWindow.addEventListener('message', veHandler, false);
    } else {
      this.windowService.nativeWindow.attachEvent('onmessage', veHandler);
    }

    oMyPlugin.subscribe('ChannelSelector.opened', (e) => {
      this.channelSelectorActive = true;
    });
    oMyPlugin.subscribe('ChannelSelector.closed', (e) => {
      this.channelSelectorActive = false;
    });
  }

  setGenesysParticipantData() {
    this.windowService.nativeWindow.Genesys('command', 'Database.set', {
      messaging: {
        customAttributes: this.participantData,
      },
    });
  }

  presetWebMessenger() {
    if (typeof this.windowService.nativeWindow.Genesys === 'function') {
      this.windowService.nativeWindow.Genesys('subscribe', 'Messenger.ready', (o) => {
        this.windowService.nativeWindow.Genesys('subscribe', 'Messenger.closed', () => {
          this.setGenesysParticipantData();
        });
        this.windowService.nativeWindow.Genesys('subscribe', 'Messenger.opened', () => {
          this.setGenesysParticipantData();
        });
        this.webMessengerEnabled = true;
        if (this.enableGenesysCobrowse) {
          this.cobrowseEnabled = true;
        }
        if (this.participantData) {
          if (this.participantData['WP-Is-1851']) {
            this.videoEngagerEnabled = true;
          }
          this.setGenesysParticipantData();
        }
      });
    }
  }

  preFillGenesysWidget() {
    if (this.participantData && this.participantData['WP-Is-1851']) {
      this.loadVideoEngagerScript();
    }
    setInterval(() => {
      this.presetWebMessenger();
    }, 1);
  }
}
